import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	tooltipContent: {
		maxWidth: 320,
		padding: 0,
		whiteSpace: 'normal',
	},
	tooltipHeader: {
		borderBottom: `1px solid ${THEME.colors.border.light}`,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
		padding: `${THEME.spacing.sm}px ${THEME.spacing.md}px`,
	},
	memberCard: {
		borderBottom: `1px solid ${THEME.colors.border.light}`,
		padding: `${THEME.spacing.sm}px ${THEME.spacing.md}px`,
		':last-child': {
			borderBottom: 'none',
		},
	},
	memberName: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
	},
	memberEmail: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		marginTop: THEME.spacing.xs,
		overflowWrap: 'anywhere',
	},
	memberEmailMissing: {
		color: THEME.colors.danger.main,
		fontSize: THEME.typography.fontSizes.xs,
		marginTop: THEME.spacing.xs,
	},
});
